<!--
  Self-contained "Change History" button + modal (Enhanced Audit Trail).
  Drop a single tag into any edit view's header:
    <audit-history-button entity-type="Finding" :record-id="id" title="Finding Change History" />
  Registered globally in main.js, so no per-view import/registration needed.
-->
<template>
  <span v-if="recordId" class="audit-history-button">
    <v-btn size="small" variant="text" color="primary" @click="show = true">
      <v-icon left size="18">mdi-history</v-icon>
      Change History
    </v-btn>
    <audit-history-modal
      v-model="show"
      :entity-type="entityType"
      :record-id="recordId"
      :title="title"
    />
  </span>
</template>

<script setup>
import { ref } from "vue";
import AuditHistoryModal from "./AuditHistoryModal.vue";

defineProps({
  entityType: { type: String, required: true },
  recordId: { type: [String, Number], default: null },
  title: { type: String, default: "Change History" },
});

const show = ref(false);
</script>

<style scoped>
.audit-history-button {
  display: inline-flex;
  align-items: center;
}
</style>
